<template>
  <div>
    <a-popover v-if="$store.state.routeName.fullPath == '/research-list'">
      <template #content> {{ label }} </template>
      <a-upload
        v-if="!isLoading"
        :before-upload="beforeUpload"
        :custom-request="customRequest"
        :show-upload-list="false"
        accept="image/png, image/jpeg, application/pdf"
      >
        <button v-if="!fileUploaded && !uploading">
          <BaseIcon name="uploadIcon" v-if="!fileUploaded" />
        </button>
      </a-upload>
    </a-popover>

    <!-- <a-upload
      :before-upload="beforeUpload"
      :custom-request="customRequest"
      :show-upload-list="false"
      accept="image/png, image/jpeg, application/pdf"
    >
      <a-button v-if="!fileUploaded && !uploading">
        <div class="flex gap-1 justify-center items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.76539 7.55817H13.6268C13.6561 7.55817 13.6841 7.56979 13.7048 7.59048C13.7255 7.61117 13.7371 7.63923 13.7371 7.66849V12.8538C13.7371 13.322 13.5512 13.771 13.2201 14.102C12.8891 14.4331 12.4401 14.6191 11.9719 14.6191H6.23494C5.76677 14.6191 5.31778 14.4331 4.98674 14.102C4.65569 13.771 4.46971 13.322 4.46971 12.8538V9.75532C3.17862 9.64775 2.26318 8.59634 2.26318 7.17561V4.91033C2.26318 4.79329 2.30968 4.68104 2.39244 4.59828C2.4752 4.51552 2.58745 4.46903 2.70449 4.46903C2.82153 4.46903 2.93378 4.51552 3.01654 4.59828C3.0993 4.68104 3.1458 4.79329 3.1458 4.91033V7.17561C3.1458 7.65691 3.29667 8.09215 3.57083 8.40189C3.84913 8.7166 4.2361 8.88209 4.69037 8.88209C5.14464 8.88209 5.53161 8.7166 5.80991 8.40189C6.08407 8.09215 6.23494 7.65691 6.23494 7.17561V3.34866C6.23494 3.09408 6.17122 2.2625 5.35233 2.2625C4.70168 2.2625 4.46971 2.83233 4.46971 3.36576V7.33751C4.46971 7.51845 4.62886 7.55817 4.69037 7.55817C4.7196 7.55913 4.74872 7.55408 4.77593 7.54333C4.80313 7.53258 4.82784 7.51636 4.84853 7.49568C4.86921 7.47499 4.88543 7.45028 4.89618 7.42308C4.90693 7.39587 4.91198 7.36675 4.91102 7.33751V3.14511C4.91102 3.02807 4.95751 2.91582 5.04028 2.83306C5.12304 2.7503 5.23528 2.7038 5.35233 2.7038C5.46937 2.7038 5.58162 2.7503 5.66438 2.83306C5.74714 2.91582 5.79363 3.02807 5.79363 3.14511V7.33751C5.79522 7.48284 5.76777 7.62702 5.71289 7.76159C5.658 7.89616 5.5768 8.01841 5.47403 8.12118C5.37127 8.22395 5.24901 8.30515 5.11444 8.36003C4.97987 8.41492 4.83569 8.44237 4.69037 8.44078C4.14811 8.44078 3.5871 8.02706 3.5871 7.33751V3.36576C3.5871 2.19657 4.31305 1.37988 5.35233 1.37988C5.89265 1.37988 6.36512 1.59723 6.68314 1.99192C6.75091 2.07654 6.81091 2.1671 6.86242 2.2625H8.33114C8.3604 2.2625 8.38846 2.27412 8.40915 2.29481C8.42985 2.3155 8.44147 2.34356 8.44147 2.37282V6.23425C8.44147 6.58537 8.58095 6.92212 8.82924 7.1704C9.07752 7.41868 9.41426 7.55817 9.76539 7.55817ZM14.0567 6.49966H10.0002C9.86755 6.49966 9.74038 6.44698 9.64661 6.35321C9.55284 6.25944 9.50016 6.13227 9.50016 5.99966V1.9431C9.50021 1.93077 9.50391 1.91874 9.51078 1.90851C9.51765 1.89828 9.52739 1.89031 9.53878 1.8856C9.55017 1.88089 9.56269 1.87966 9.57478 1.88205C9.58687 1.88444 9.59799 1.89035 9.60673 1.89903L14.1008 6.3931C14.1095 6.40184 14.1154 6.41295 14.1178 6.42504C14.1202 6.43713 14.1189 6.44965 14.1142 6.46104C14.1095 6.47243 14.1015 6.48217 14.0913 6.48904C14.0811 6.49591 14.069 6.49961 14.0567 6.49966Z"
              fill="#ED4081"
            />
          </svg>
          <p>{{ label }}</p>
        </div>
      </a-button>
    </a-upload> -->

    <div v-if="!uploading && isLoading">
      <div class="flex justify-between items-center gap-1">
        <div
          :style="{
            textOverflow: 'ellipsis',
            width: '80%',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }"
        >
          <a v-if="fileName" @click="fileDownLoaded">{{ fileName }}</a>
          <p v-else :style="{ opacity: '0.6', fontSize: '14px' }">ไม่พบไฟล์</p>
          <!-- {{ fileName ? fileName : "ไม่พบไฟล์" }} -->
        </div>

        <div class="flex items-center gap-2">
          <!-- upload again -->
          <a-upload
            :before-upload="beforeUpload"
            :custom-request="customRequest"
            :show-upload-list="false"
            accept="image/png, image/jpeg, application/pdf"
          >
            <a-popover
              v-if="$store.state.routeName.fullPath == '/research-list'"
            >
              <template #content> แก้ไข </template>
              <button v-if="fileUploaded">
                <BaseIcon name="pencilIcon" />
              </button>
            </a-popover>
            <a-popover
              v-if="$store.state.routeName.fullPath == '/research-list'"
            >
              <template #content> {{ label }} </template>
              <button v-if="!fileUploaded">
                <BaseIcon name="uploadIcon" />
              </button>
            </a-popover>
          </a-upload>

          <!-- download button -->
          <a-popover>
            <template #content> ดาวน์โหลด </template>
            <button @click="fileDownLoaded">
              <BaseIcon name="downloadIcon" v-if="fileUploaded" />
            </button>
          </a-popover>
        </div>
      </div>
    </div>

    <a-progress
      v-if="uploading && isLoading"
      :percent="uploadPercent"
      :status="uploadStatus"
      show-info
    />
  </div>
</template>

<script>
import BaseIcon from "./Icon/BaseIcon.vue";
export default {
  components: { BaseIcon },
  props: {
    fileSelected: {
      Type: Function,
    },
    fileDownLoaded: {
      Type: Function,
    },
    isLoading: {
      Type: Boolean,
      default: true,
    },
    label: {
      Type: String,
    },
    defaultFile: {
      Type: String,
    },
  },

  watch: {
    defaultFile(newValue, oldValue) {
      if (newValue && newValue.name != null) {
        this.fileName = newValue.name;
        this.fileUploaded = true;
      } else {
        this.fileName = "";
        this.fileUploaded = false;
      }
    },
  },

  methods: {
    beforeUpload(file) {
      const isAllowedType = [
        "image/png",
        "image/jpeg",
        "application/pdf",
      ].includes(file.type);
      if (!isAllowedType) {
        // this.$message.error("You can only upload JPG, PNG, or PDF files!");
      }
      return isAllowedType;
    },

    customRequest({ file, onSuccess, onProgress }) {
      if (this.isLoading) {
        this.uploading = true;
        const totalSize = 100;
        const step = 20;

        const interval = setInterval(() => {
          if (this.uploadPercent < totalSize) {
            this.uploadPercent += step;
            onProgress({ percent: this.uploadPercent });
          } else {
            clearInterval(interval);
            this.uploadPercent = 0;
            this.uploading = false;
            this.fileUploaded = true;
            this.fileName = file.name;
            this.fileSelected(file);
            onSuccess();
          }
        }, 500);
      } else {
        this.fileSelected(file);
      }
    },
  },

  data() {
    return {
      // fileUpload: "",
      uploading: false,
      uploadPercent: 0,
      uploadStatus: "active",
      fileUploaded: false,
      fileName: "",
    };
  },
};
</script>

<style scoped></style>
